"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPushPullAddPagePopup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const react_redux_1 = require("react-redux");
const PopupRedux = tslib_1.__importStar(require("@adaptabletools/adaptable/src/Redux/ActionsReducers/PopupRedux"));
const IPushPullRedux = tslib_1.__importStar(require("../Redux/ActionReducers/IPushPullRedux"));
const StringExtensions_1 = require("@adaptabletools/adaptable/src/Utilities/Extensions/StringExtensions");
const FormLayout_1 = tslib_1.__importStar(require("@adaptabletools/adaptable/src/components/FormLayout"));
const Input_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/components/Input"));
const SimpleButton_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/components/SimpleButton"));
const FlexWithFooter_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/components/FlexWithFooter"));
const PanelWithImage_1 = require("@adaptabletools/adaptable/src/View/Components/Panels/PanelWithImage");
const PopupContext_1 = require("@adaptabletools/adaptable/src/View/Components/Popups/AdaptablePopup/PopupContext");
const ErrorBox_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/components/ErrorBox"));
const HelpBlock_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/components/HelpBlock"));
const rebass_1 = require("rebass");
const Dropdown_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/components/Dropdown"));
const GeneralConstants_1 = require("@adaptabletools/adaptable/src/Utilities/Constants/GeneralConstants");
const ArrayExtensions_1 = tslib_1.__importDefault(require("@adaptabletools/adaptable/src/Utilities/Extensions/ArrayExtensions"));
const IPushPullAddPageComponent = (props) => {
    const [state, setState] = React.useState({
        Folder: '',
        Page: '',
        AvailablePages: GeneralConstants_1.EMPTY_ARRAY,
        ErrorMessage: '',
    });
    const { hidePopup } = (0, PopupContext_1.usePopupContext)();
    const onSubmit = () => {
        if (ArrayExtensions_1.default.ContainsItem(state.AvailablePages, state.Page)) {
            setState(Object.assign(Object.assign({}, state), { ErrorMessage: 'A page with that name already exists in the folder' }));
        }
        else {
            props.onAddPage(state.Folder, state.Page);
        }
    };
    const onPageNameChange = (event) => {
        const e = event.target;
        setState(Object.assign(Object.assign({}, state), { Page: e.value }));
    };
    const onFolderChanged = (folderName) => {
        if (StringExtensions_1.StringExtensions.IsNotNullOrEmpty(folderName) && folderName !== 'Select Folder') {
            let avaialablePages = props.IPushPullDomainsPages.find((f) => f.Name == folderName).Pages;
            setState({
                Folder: folderName,
                AvailablePages: avaialablePages,
                Page: GeneralConstants_1.EMPTY_STRING,
                ErrorMessage: GeneralConstants_1.EMPTY_STRING,
            });
        }
        else {
            setState({
                Folder: GeneralConstants_1.EMPTY_STRING,
                AvailablePages: [],
                Page: GeneralConstants_1.EMPTY_STRING,
                ErrorMessage: GeneralConstants_1.EMPTY_STRING,
            });
        }
    };
    const availableFolders = props.IPushPullDomainsPages.map((iPushPullDomain) => {
        return {
            label: iPushPullDomain.Name,
            value: iPushPullDomain.Name,
        };
    });
    return (React.createElement(PanelWithImage_1.PanelWithImage, { header: "Add ipushpull Page", glyphicon: "newpage", variant: "primary", style: { height: '100%' } },
        React.createElement(FlexWithFooter_1.default, { as: "form", onSubmit: (e) => {
                e.preventDefault();
                onSubmit();
            }, footerProps: {
                fontSize: 'var(--ab-font-size-4)',
            }, footer: React.createElement(React.Fragment, null,
                React.createElement(SimpleButton_1.default, { tone: "neutral", variant: "text", tooltip: "Close", onClick: (e) => {
                        e.stopPropagation();
                        hidePopup();
                    } }, "CLOSE"),
                React.createElement("div", { style: { flex: 1 } }),
                React.createElement(SimpleButton_1.default, { tone: "accent", variant: "raised", type: "submit", disabled: StringExtensions_1.StringExtensions.IsNullOrEmpty(state.Folder) ||
                        StringExtensions_1.StringExtensions.IsNullOrEmpty(state.Page), icon: 'check' }, "Add Page")) },
            React.createElement(rebass_1.Flex, { flexDirection: "column", padding: 2, margin: 2 },
                React.createElement(HelpBlock_1.default, { marginBottom: 1 }, "Select a folder and then choose the name of the new ipushpull page it should contain."),
                React.createElement(FormLayout_1.default, { margin: 3 },
                    React.createElement(FormLayout_1.FormRow, { label: "Folder:" },
                        React.createElement(Dropdown_1.default, { disabled: availableFolders.length == 0, style: { minWidth: '50%' }, options: availableFolders, className: "ab-Popup__IPushPull__select", onChange: (folder) => onFolderChanged(folder), value: state.Folder ? state.Folder : null, placeholder: "Select Folder", marginRight: 2 })),
                    React.createElement(FormLayout_1.FormRow, { label: "Page" },
                        React.createElement(Input_1.default, { width: "50%", type: "text", placeholder: "Page Name", value: state.Page, onChange: onPageNameChange })),
                    state.ErrorMessage ? (React.createElement(FormLayout_1.FormRow, { label: "" },
                        React.createElement(ErrorBox_1.default, null, state.ErrorMessage))) : null)))));
};
function mapStateToProps(state) {
    return {
        IPushPullDomainsPages: state.System.IPushPullDomainsPages,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onAddPage: (folder, page) => dispatch(IPushPullRedux.IPushPullAddPage(folder, page)),
        onCancel: () => {
            dispatch(PopupRedux.PopupHideScreen());
        },
    };
}
exports.IPushPullAddPagePopup = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(IPushPullAddPageComponent);
